var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.isSocialMediaIcon)?_c('span',{style:({
    fontSize: _vm.iconSize,
    lineHeight: _vm.iconSize,
  })},[_c('b-icon',{attrs:{"icon":_vm.icon}})],1):_c('span',{staticClass:"material-symbols",style:({ fontVariationSettings: _vm.fontVariationSettings, fontSize: _vm.iconSize })},[_vm._v(" "+_vm._s(_vm.iconName)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }